<template>
    <el-card shadow="never">
        404 not found page
    </el-card>
</template>

<script setup lang="ts">
</script>